module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    staticClass: "content-wrapper"
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.places != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по событиям\n")]) : _c('div', {
    staticStyle: {
      "width": "100vw",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "datalist"
  }, [_c('div', {
    staticClass: "datalist-scroll"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "font-size": "5px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), ((_vm.activeUser != null)) ? _c('div', {
    staticClass: "place place-dashed-border"
  }, [_c('div', {
    staticClass: "place-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticClass: "place-edit-link link",
    attrs: {
      "to": "/place-edit"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle",
    staticStyle: {
      "font-size": "48px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Добавить место")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "place-info",
    staticStyle: {
      "background": "#D9E0E7"
    }
  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredData), function(place, key) {
    return _c('div', {
      key: place.val.id,
      staticClass: "place",
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(place)
        }
      }
    }, [_c('div', {
      staticClass: "place-image",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(place.val.images[0]) + ')'
      })
    }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('DIV', {
      staticClass: "place-info"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "0px 0 0 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "place-name"
    }, [_vm._v(_vm._s(place.val.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "10px 0 0 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "place-prop"
    }, [_vm._v(_vm._s(place.val.city) + ", " + _vm._s(place.val.address))])]), _vm._v(" "), (place.val.description != '') ? _c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "10px 0 0px 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "place-prop"
    }, [_vm._v(_vm._s(place.val.description))])]) : _vm._e()])], 1)
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9edcfb9c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Places.vue
// module id = 365
// module chunks = 0